<div class="grid grid-cols-[3rem_5rem_1fr] pt-2">
    <div>
        <p class="flex items-start text-[#414141] dark:text-contrast-yellow">
            {{ time + (delay || 0) * 1000 | momentDate: 'HH:mm' : env.TIMEZONE }}
        </p>
        <p
            class="ml-1 flex items-center text-sm text-[#414141] line-through dark:text-contrast-yellow"
            *ngIf="isDelayed">
            {{ time | momentDate: 'HH:mm' : env.TIMEZONE }}
        </p>
    </div>
    <div class="flex items-start justify-center">
        <ion-icon
            class="text-2xl text-[#838383] dark:text-contrast-yellow"
            src="{{ assetsPath$ | async }}/img/journey-planner/destination.svg"
            title="{{ 'DESTINATION' | translate }}"
            aria-hidden="true"></ion-icon>
    </div>
    <p class="flex items-start">
        <ng-container *ngIf="legName; else useDefaultDestination">
            <ng-container [ngSwitch]="legName">
                <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate | titlecase }}</span>
                <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate | titlecase }}</span>
                <span *ngSwitchDefault>{{ legName | titlecase }}</span>
            </ng-container>
        </ng-container>
        <ng-template #useDefaultDestination>
            {{ 'ITINERARY_INSTRUCTIONS_DESTINATION' | translate | titlecase }}
        </ng-template>
    </p>
</div>
